import React, { Fragment,useEffect, useState,useContext } from "react";
import { getAllCarType } from "../../../Services/Car.service";
import DataTable from "react-data-table-component";
import ActionOptions from "../../Common/Component/ActionOptions";
import { DropdownItem } from "reactstrap";
import { Spinner } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
import {CarTypeColumns} from '../../../Data/CarType/CarType';
import {deleteRecoverCarType} from '../../../Services/Car.service'
import { showAlert } from "../../../Services/Shared.service";
function CarTypeTable({ isRefresh,

    carTypeData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    onEditClick,
    loader,
    editId,
    setEditId,
    triggerRefresh,
 }) {

//   const [carTypeData,setCarTypeData] = useState([]);
  const {mix_background_layout} = useContext(CustomizerContext)
  const[carTypeObj,setCartypeObj] = useState();

  const conditionalRowStyles = [

      {
        when: row => row["Deleted"] ,
        style: row => ({ backgroundColor: row["Deleted"] ? "#F9B5A6" : ""}),
      },
  ];


const isDeleteUpdate =(carTypeId,isDelete)=>{
    console.log("carTypeId",carTypeId)
    const obj = {
        id:carTypeId,
        IsDeleted:isDelete
    }

    deleteRecoverCarType(obj).then((resp)=>{
        triggerRefresh()
            showAlert("success","Deleted successfully");
    }).catch((err)=>{
        showAlert("error","Can't able to delete")
    })
    
}

const processData = carTypeData.map((element, index) => {
    return {
        Name: element.name ? element.name : "-",
        Seats: element.noOfSeats ? element.noOfSeats : "-",
        Passengers: element.noOfPassenger ? element.noOfPassenger : "-",
        Bags: element.noOfBags ? element.noOfBags:"-",
        IsDeleted:element.isDeleted? "True":"False",
        Deleted: element.isDeleted,
        action: (
            <ActionOptions key={index}>
                <Fragment>
                    <DropdownItem
                        className="border-0"
                        key={"row-edit"}
                        onClick={() => {
                          // console.log("isupdate params",element.id,element.isDeleted?false:true)
                           isDeleteUpdate(element.id,element.isDeleted?false:true)
                        }}
                    >
                        <i className="fa fa-trash-o"></i> {element.isDeleted ? "Recover" : "Delete"}
                    </DropdownItem>
                </Fragment>
            </ActionOptions>
        ),
    };
});

  return (
    <div>
      <div className="table-responsive corporate-client-table">
        <DataTable
          columns={CarTypeColumns}
          data={processData}
          center={true}
          fixedHeader
          fixedHeaderScrollHeight={"57vh"}
          pagination
          paginationPerPage={paginationPerPage}
          paginationTotalRows={paginationTotalRows}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          // customStyles={customStyles}
          conditionalRowStyles={conditionalRowStyles}
          paginationServer
          progressPending={loader}
          progressComponent={
            <div className="loader-box" style={{ height: "57vh" }}>
              <Spinner
                attrSpinner={{
                  className: "loader-3",
                  style: {
                    width: "30px",
                    height: "30px",
                    borderColor: "#39B54A",
                    borderBottomColor: "transparent",
                  },
                }}
              />
            </div>
          }
          theme={mix_background_layout == "dark-only" ? "dark" : "default"}
        />
      </div>
    </div>
  );
}

export default CarTypeTable;
